// extracted by mini-css-extract-plugin
export default {"wrap":"InfoTip_wrap__+CAoy","glue":"InfoTip_glue__eYdEV","icon":"InfoTip_icon__OFkmI","tip":"InfoTip_tip__gKKBb","tipBottom":"InfoTip_tipBottom__YFKQh"};